exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#logout-btn{\n  cursor: pointer;\n}\n\n.menu:not(.top) {\n  background-color: #004274!important;\n}\n\n.menu:not(.top) .item{\n  color: #ffffff !important;\n}\n\n.menu:not(.top) .item:first-child{\n  background-color: #ffffff !important;\n  width: 101%;\n}\n\n.menu:not(.top) .item:first-child img{\n  width: 65px;\n  margin: auto;\n}\n\n.menu:not(.top) .item:hover{\n  color: #157FA7 !important;\n  cursor: pointer;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/navigation/navigation.component.css
// module id = ../../../../../src/app/_components/navigation/navigation.component.css
// module chunks = main